import { Button, Tooltip } from '$components'
import { useFormContext } from 'react-hook-form'
import { UpdateLocationSchema, useUpdateLocationForm } from '.'
import { useTenant } from '$features/auth/hooks/use-tenant'
import { SUBSCRIPTION_EXPIRED_MESSAGE } from '$constants/subscription'

export function UpdateLocationFormControls() {
  const { formState: { isSubmitting } } = useFormContext<UpdateLocationSchema>()
  const { onCancel, isLoading } = useUpdateLocationForm()
  const { hasSubscriptionExpired } = useTenant()

  const isButtonDisabled = hasSubscriptionExpired || isLoading || isSubmitting

  return (
    <div className="flex justify-end gap-stack">
      <Button
        variant="ghost"
        onClick={onCancel}
      >
        Cancel
      </Button>

      <Tooltip
        content={hasSubscriptionExpired ? SUBSCRIPTION_EXPIRED_MESSAGE : undefined}
        disabled={!hasSubscriptionExpired}
      >
        <Button
          type="submit"
          size="lg"
          isLoading={isLoading || isSubmitting}
          disabled={isButtonDisabled}
        >
          Update Location
        </Button>
      </Tooltip>
    </div>
  )
}
